import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=150ba7bb&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=150ba7bb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ba7bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150ba7bb')) {
      api.createRecord('150ba7bb', component.options)
    } else {
      api.reload('150ba7bb', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=150ba7bb&scoped=true", function () {
      api.rerender('150ba7bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/Index.vue"
export default component.exports